"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontCapabilities = void 0;
var FrontCapabilities;
(function (FrontCapabilities) {
    FrontCapabilities["FILE_SYSTEM_INTERNAL_STORAGE"] = "FILE_SYSTEM_INTERNAL_STORAGE";
    FrontCapabilities["FILE_SYSTEM_EXTERNAL_STORAGE"] = "FILE_SYSTEM_EXTERNAL_STORAGE";
    FrontCapabilities["FILE_SYSTEM_FILE_CHECKSUM"] = "FILE_SYSTEM_FILE_CHECKSUM";
    FrontCapabilities["FILE_SYSTEM_LINK"] = "FILE_SYSTEM_LINK";
    FrontCapabilities["TIMERS_PROPRIETARY"] = "TIMERS_PROPRIETARY";
    FrontCapabilities["VIDEO_4K"] = "VIDEO_4K";
    FrontCapabilities["SERIAL"] = "SERIAL";
    FrontCapabilities["BARCODE_SCANNER"] = "BARCODE_SCANNER";
    FrontCapabilities["FRONT_OSD"] = "FRONT_OSD";
    FrontCapabilities["SUPRA"] = "SUPRA";
    FrontCapabilities["FILE_SYSTEM_CREATE_ARCHIVE"] = "FILE_SYSTEM_CREATE_ARCHIVE";
    /**
     * Information about total size of all files when archive will be extracted
     */
    FrontCapabilities["FILE_SYSTEM_ARCHIVE_EXTRACT_INFO"] = "FILE_SYSTEM_ARCHIVE_EXTRACT_INFO";
    FrontCapabilities["BROWSER"] = "BROWSER";
    FrontCapabilities["PROXIMITY_SENSOR"] = "PROXIMITY_SENSOR";
})(FrontCapabilities || (exports.FrontCapabilities = FrontCapabilities = {}));
